export { remoteConfigAdapter } from '@/adapters/remoteConfig/remoteConfigAdapter';
